export const normalizeApiCartItem = (item) => ({
  id: item?.product_id ?? item?.id,
  name: item?.product?.product_name ?? item?.name ?? "Product",
  subtitle: item?.product?.brand ?? item?.subtitle ?? "",
  price:
    item?.product?.pricing?.sale_price ??
    item?.product?.pricing?.regular_price ??
    item?.price ??
    0,
  qty: item?.quantity ?? item?.qty ?? 1,
  inStock: item?.product?.status === "active" || item?.inStock !== false,
  img: item?.product?.images?.[0]?.image_url ?? item?.img ?? "",
});
